import { Link } from "react-router-dom";

import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Grid01.css";

import icon from "../../../img/icons/link.svg";
import RivePlayer from "../../extras/RivePlayer01";

function Grid01() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`Grid01 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Grid01"
    >
      <div className="container">
        <div className="intro">
          <p className="eyebrow">Services</p>
          <h2>Our Protection Framework</h2>
          <p>Comprehensive protection for elite creators.</p>
        </div>
        <div className="Grid01-box">
          <div className="Grid01-card">
            <RivePlayer src="/rive/revenue.riv" />
            <div className="Grid01-card-text">
              <h3>Fingerprinting & Hash Matching</h3>
              <p>Standard takedown services rely on text-based keywords...</p>
              <Link
                className="link"
                to="/services/fingerprinting-hash-matching"
              >
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>

          <div className="Grid01-card">
            <RivePlayer src="/rive/scanner.riv" />
            <div className="Grid01-card-text">
              <h3>Hidden Leak Detection</h3>
              <p>
                Leaks rarely stay visible on public search results for long...
              </p>
              <Link className="link" to="/services/hidden-leak-detection">
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>

          <div className="Grid01-card">
            <RivePlayer src="/rive/notifications.riv" />
            <div className="Grid01-card-text">
              <h3>Visual Impersonation AI</h3>
              <p>
                Pirates frequently rename files, remove metadata, or crop
                content...
              </p>
              <Link className="link" to="/services/visual-impersonation-ai">
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>

          <div className="Grid01-card">
            <RivePlayer src="/rive/distribution.riv" />
            <div className="Grid01-card-text">
              <h3>Multi-Layer Distribution</h3>
              <p>
                When content leaks, it rarely stays in one place. A single
                upload...
              </p>
              <Link className="link" to="/services/multi-layer-distribution">
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>

          <div className="Grid01-card">
            <RivePlayer src="/rive/network.riv" />
            <div className="Grid01-card-text">
              <h3>Creator Protection Circle</h3>
              <p>
                A private network built through years of working alongside...
              </p>
              <Link className="link" to="/services/creator-protection-circle">
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>

          <div className="Grid01-card">
            <RivePlayer src="/rive/encryption.riv" />
            <div className="Grid01-card-text">
              <h3>Secure Creator Infrastructure</h3>
              <p>
                Protecting creator content means handling sensitive media...
              </p>
              <Link
                className="link"
                to="/services/secure-creator-infrastructure"
              >
                Learn More <img src={icon} alt="arrow" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Grid01;
